import { Tooltip } from '@material-ui/core';
import React, { JSX, useState } from 'react';
import { Link } from 'react-router-dom';

import { track } from '~/src/dash/analytics/analytics';
import {
  ECampaignDeliveryStatus,
  ECampaignStatusToSticker,
} from '~/src/dash/components/filters/options/campaigns';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { ICustomRenderCellJSXProps } from '~/src/dash/components/tables/ListViewTable/common';
import { Col, Cols, Row, Rows, spacing, Text, TooltipWithTranslation } from '~/src/dash/publicaUI';
import {
  extractRouteParams,
  getRoutePath,
  RouteOrderSettingsExisting,
} from '~/src/dash/router/routes';
import { publicaColors } from '~/src/dash/utils/colors';
import { useBaseStore } from '~/src/dash/views/base/contexts';

export const CampaignStatusRender = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { color, backgroundColor, tKey, tooltipTKey } = ECampaignStatusToSticker(
    props.value as ECampaignDeliveryStatus,
  );
  return (
    <TooltipWithTranslation tKey={tooltipTKey}>
      <div>
        <Text
          singleLineLabel
          small
          disableSelect
          tKey={tKey}
          style={{
            display: 'inline-block',
            textAlign: 'center',
            padding: '12px',
            borderRadius: '6px',
            backgroundColor,
            color,
          }}
        />
      </div>
    </TooltipWithTranslation>
  );
};
interface IOrderHyperLinkProps {
  id: string;
  label: string;
}

const OrderHyperLink = ({ id, label }: IOrderHyperLinkProps): JSX.Element => {
  const { session, user, isSuperUser } = useBaseStore();

  return (
    <Tooltip title={label} placement='top-start'>
      <div>
        <Link
          to={getRoutePath(RouteOrderSettingsExisting, extractRouteParams({ session, user }), {
            order: id,
          })}
          target='_blank'
          onClick={() => {
            track('Line Item List - Order Link', { isSuperUser }, user.user);
          }}
          style={{
            color: 'inherit',
            textDecoration: 'inherit',
          }}
        >
          <Rows>
            <Row noPadding>
              <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
                <Col style={{ minWidth: 0, flex: 1 }}>
                  <Text
                    small
                    style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
                  >
                    {label}
                  </Text>
                </Col>
                <Col displayFlex>
                  <IconV2 name='externalLink' small color={publicaColors.blue} />
                </Col>
              </Cols>
            </Row>
            <Row noPadding>
              <Text extraSmall muted style={{ paddingBottom: '3px' }}>
                {`ID: ${id}`}
              </Text>
            </Row>
          </Rows>
        </Link>
      </div>
    </Tooltip>
  );
};

export const OrderRender = (props: ICustomRenderCellJSXProps): JSX.Element => {
  const { value, row } = props;
  return (
    <OrderHyperLink id={String(row.OrderID.value as unknown as number)} label={value as string} />
  );
};
